import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "rules", "minLength", "lowercase", "uppercase", "digit", "special", "allValid"]

  connect() {
    this.validate();
  }

  focus() {
    this.validate();
  }

  blur() {
    this.validate();
  }

  validate() {
    const password = this.inputTarget.value;

    const rules = [
      { target: this.minLengthTarget, valid: password.length >= 8 },
      { target: this.lowercaseTarget, valid: /[a-z]/.test(password) },
      { target: this.uppercaseTarget, valid: /[A-Z]/.test(password) },
      { target: this.digitTarget, valid: /[0-9]/.test(password) },
      { target: this.specialTarget, valid: /[!@#$%^&*_=+\-]/.test(password) }
    ];

    rules.forEach(rule => {
      if (rule.valid) {
        rule.target.classList.add('text-success');
        rule.target.classList.remove('text-muted');
        if (!rule.target.dataset.originalText) {
          rule.target.dataset.originalText = rule.target.textContent;
        }
        rule.target.textContent = '✓ ' + rule.target.dataset.originalText;
      } else {
        rule.target.classList.remove('text-success');
        rule.target.classList.add('text-muted');
        if (rule.target.dataset.originalText) {
          rule.target.textContent = rule.target.dataset.originalText;
        }
      }
    });

    // Show/hide the rules container
    if (password.length === 0) {
      this.rulesTarget.style.display = 'none';
    } else {
      this.rulesTarget.style.display = 'block';
    }
  }
}
